var map = {
	"./level0.svg": "e0d7",
	"./level1.svg": "07f1",
	"./level2.svg": "1491",
	"./level3.svg": "c67a",
	"./level4.svg": "a8cb",
	"./level5.svg": "ae7c",
	"./levelnull.svg": "7961"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a033";